import { clsx } from 'clsx'

import { FC } from 'react'

import { IconDeutschLogo, IconEspanolLogo, IconLogo } from '@/app/shared/icons'
import { IClassName } from '@/app/shared/interfaces/common.interface'
import { ITypeSite } from '@/app/shared/store/layout.store'

// interface
interface ILogo extends IClassName {
  footer?: boolean
  text?: string
  classIcon?: string
  typeSite: ITypeSite | null
}

const LogoComponent: FC<Readonly<ILogo>> = ({ footer, text, className, classIcon, typeSite }) => {
  return (
    <div
      className={clsx('relative gap-2', className, { 'grid w-[163px] lg:flex lg:w-fit': footer })}
    >
      {typeSite === 'online-deutsch' && (
        <IconDeutschLogo
          className={clsx(
            'block text-content1-200',
            {
              'h-[69px] w-[89px] laptop:h-[97px] laptop:w-[125px]': !footer,
              'h-[125px] w-[163px]': footer,
            },
            classIcon,
          )}
        />
      )}
      {typeSite === 'online-espanol' && (
        <IconEspanolLogo
          className={clsx(
            'block text-content1-200',
            {
              'h-[69px] w-[89px] laptop:h-[97px] laptop:w-[125px]': !footer,
              'h-[125px] w-[163px]': footer,
            },
            classIcon,
          )}
        />
      )}
      {(typeSite === 'offline' || typeSite === 'online' || typeSite === 'kids') && (
        <IconLogo
          className={clsx(
            'block text-content1-200',
            {
              'h-[69px] w-[89px] laptop:h-[97px] laptop:w-[125px]': !footer,
              'h-[125px] w-[163px]': footer,
            },
            classIcon,
          )}
        />
      )}
      <span
        className={clsx('font-semibold lg:whitespace-nowrap', {
          'absolute bottom-0 left-8 whitespace-nowrap text-[7px] uppercase laptop:left-10 laptop:text-base':
            !footer,
          'static flex items-center text-[16px] text-base desktop:text-[22px]': footer,
        })}
      >
        {text ??
          `школа ${typeSite === 'online-deutsch' ? 'німецької' : typeSite === 'online-espanol' ? 'іспанської' : 'англійської'} мови`}
      </span>
    </div>
  )
}

export default LogoComponent
